import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useImprovedTranslation } from '@xanadu/ui-shared/hooks';

import IconClose from '../../../../../images/icons/misc/close.svg';

import styles from './Card.module.scss';

const Card = forwardRef((props, ref) => {
  const { t } = useImprovedTranslation();
  const {
    index,
    title,
    content,
    isVisible,
    isLoggedIn,
    activeIndex,
    stepsContent,
    onEndTour,
    onJoinNow,
    onPrevious,
    onNext
  } = props;

  const isPredictionsTitle = title.includes('predictions-onboarding-step__headerContent');
  const isPredictionsContent = content.includes('predictions-onboarding-step');

  const mainClass = classNames({
    [styles.main]: true,
    [styles['main--visible']]: isVisible,
  });

  const headerClass = classNames({
    [styles.header]: true,
    [styles['header--predictions']]: isPredictionsTitle,
  });

  const contentClass = classNames({
    [styles.content]: true,
    [styles['content--predictions']]: isPredictionsContent,
  });

  return (
    <div className={mainClass} ref={ref}>
      <button className={styles.close} onClick={onEndTour}>
        <IconClose />
      </button>
      <div>
        <div
          className={headerClass}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div
          className={contentClass}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
      <div className={styles.footer}>
        <div>
          {index ? (
            <button onClick={onPrevious}>{t('Previous')}</button>
          ) : <div />}
        </div>
        <div className={styles.steps}>
          {stepsContent.map((step, cardIndex) => (
            <span
              key={step.title}
              {...(cardIndex === activeIndex && { className: styles.activeStep })}
            />
          ))}
        </div>
        {index === stepsContent.length - 1 ? (
          <div>
            {isLoggedIn ? (
              <button onClick={onEndTour}>{t('End Tour')}</button>
            ) : (
              <button onClick={onJoinNow}>{t('Join Now')}</button>
            )}
          </div>
        ) : (
          <div>
            <button onClick={onNext}>{t('Next')}</button>
          </div>
        )}
      </div>
    </div>
  );
});

Card.propTypes = {
  index: PropTypes.number.isRequired,
  isVisible: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  activeIndex: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  stepsContent: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  })).isRequired,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onEndTour: PropTypes.func.isRequired,
  onJoinNow: PropTypes.func.isRequired,
};

export default Card;
